export default __webpack_public_path__ + "static/media/profile.1cd16604.png";